import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "../../../utils/flash";
import migrationService from "./migrationService";
// import { current } from "@reduxjs/toolkit";

const initialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  isMigrated: false,
  message: "",
  uploadedDocUrl: "",
};

const migrationSlice = createSlice({
  initialState,
  name: "migration",
  reducers: {
    resetMigration: (state) => initialState,
    resetMigrationStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isMigrated = false;
      state.message = "";
    },
    setUploadedDocUrl: (state, { payload }) => {
      state.uploadedDocUrl = payload;
    },
    removeUploadedDocUrl: (state, { payload }) => {
      state.uploadedDocUrl = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(migrateStaff.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating Staff details, Please wait...");
      })
      .addCase(migrateStaff.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          state.isMigrated = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateStaff.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })

      // migrate users
      .addCase(migrateUser.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating Users, Please wait...");
      })
      .addCase(migrateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })

      // migrate customers details
      .addCase(migrateCustomer.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating Customer details, Please wait...");
      })
      .addCase(migrateCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })
      // migrate Customer Transaction
      .addCase(migrateCustomerTransaction.pending, (state) => {
        state.isLoading = true;
        flash(
          "loading",
          "Migrating Customer Transaction details, Please wait..."
        );
      })
      .addCase(migrateCustomerTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateCustomerTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })
      // migrate Customer Claim
      .addCase(migrateCustomerClaim.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating Customer Claim details, Please wait...");
      })
      .addCase(migrateCustomerClaim.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateCustomerClaim.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })
      // migrate Customer PolicyApp
      .addCase(migrateCustomerPolicyApp.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating Customer Claim details, Please wait...");
      })
      .addCase(migrateCustomerPolicyApp.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateCustomerPolicyApp.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })
      // migrate Customer Policy Risk
      .addCase(migrateCustomerPolicyRisk.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating Customer Claim details, Please wait...");
      })
      .addCase(migrateCustomerPolicyRisk.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateCustomerPolicyRisk.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })
      // migrate Journal
      .addCase(migrateJournal.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating Customer Claim details, Please wait...");
      })
      .addCase(migrateJournal.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateJournal.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })
      // migrate charts of accounts
      .addCase(migrateChartsOfAccount.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating chart of accounts, Please wait...");
      })
      .addCase(migrateChartsOfAccount.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateChartsOfAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      })
      .addCase(migrateSavingsApp.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Migrating savings application, Please wait...");
      })
      .addCase(migrateSavingsApp.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(migrateSavingsApp.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      });
  },
});

// create policy
export const migrateStaff = createAsyncThunk(
  "migrateStaff",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateStaff(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const migrateUser = createAsyncThunk(
  "migrateUser",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateUser(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const migrateCustomer = createAsyncThunk(
  "migrateCustomer",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateCustomer(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const migrateCustomerTransaction = createAsyncThunk(
  "migrateCustomerTransaction",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateCustomerTransaction(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const migrateCustomerClaim = createAsyncThunk(
  "migrateCustomerClaim",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateCustomerClaim(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const migrateCustomerPolicyApp = createAsyncThunk(
  "migrateCustomerPolicyApp",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateCustomerPolicyApp(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const migrateCustomerPolicyRisk = createAsyncThunk(
  "migrateCustomerPolicyRisk",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateCustomerPolicyRisk(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const migrateJournal = createAsyncThunk(
  "migrateJournal",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateJournal(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const migrateChartsOfAccount = createAsyncThunk(
  "migrateChartsOfAccount",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateChartsOfAccount(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const migrateSavingsApp = createAsyncThunk(
  "migrateSavingsApp",
  async (DATA, thunkAPI) => {
    try {
      return await migrationService.migrateSavingsApp(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { setUploadedDocUrl, removeUploadedDocUrl } =
  migrationSlice.actions;
export default migrationSlice.reducer;
